module.exports = __webpack_public_path__ + "img/image-hero-1-mobile.92864070.png";